import React, { useState } from 'react';
import { EventFormData } from './types';
import LearnMoreModal from './Components/LearnMoreModal';
import ReactQuill from 'react-quill';
import { isFieldInvalid } from './validationSchemas';
import { Settings } from 'lucide-react';

type SettingsFormData = Pick<EventFormData,
  'showOtherFees' | 'isOtherAttendeeRequired' | 'hasTermsAndConditions' | 'termsAndConditions' |'absorbFees'
>;

interface EventSettingsTabProps {
  formData: SettingsFormData;
  onInputChange: (field: keyof EventFormData, value: any) => void;
  activeTab: number;
}

const EventSettingsTab: React.FC<EventSettingsTabProps> = ({
  formData,
  onInputChange,
  activeTab
}) => {
  const [learnMoreModal, setLearnMoreModal] = useState(false);
  const [learnMoreModalField, setLearnMoreModalField] = useState('');
  
  const toggleLearnMoreModal = (field: string) => {
    setLearnMoreModalField(field);
    setLearnMoreModal(!learnMoreModal);
  };

  return (
    <>
      <div className={`step-tab-panel ${activeTab === 3 ? 'active' : ''}`} style={{ display: activeTab === 3 ? "flex" : "none", flexDirection: "column", gap: 24 }}>
        <div className="glass-panel" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div className="v3-section-head">
            <Settings size={14} color="#EE3F7C" /> Advanced Controls
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {!formData.absorbFees && (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid rgba(255,255,255,0.06)", paddingBottom: 16 }}>
                <div style={{ flex: 1, paddingRight: 20 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Show Fee Breakdown</div>
                  <p style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", margin: "4px 0 0 0" }}>
                    Show processing fee and ticket fee separately at checkout.
                    <span className="text-primary ms-1" style={{ cursor: "pointer" }} onClick={() => toggleLearnMoreModal('showOtherFees')}> Learn more</span>
                  </p>
                </div>
                <button type="button" className={`v3-toggle ${formData.showOtherFees ? "on" : "off"}`} onClick={() => onInputChange('showOtherFees', !formData.showOtherFees)}>
                  <span className="v3-toggle-knob" />
                </button>
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid rgba(255,255,255,0.06)", paddingBottom: 16 }}>
              <div style={{ flex: 1, paddingRight: 20 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Require All Attendee Details</div>
                <p style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", margin: "4px 0 0 0" }}>
                  Customers must provide information for every ticket holder.
                  <span className="text-primary ms-1" style={{ cursor: "pointer" }} onClick={() => toggleLearnMoreModal('isOtherAttendeeRequired')}> Learn more</span>
                </p>
              </div>
              <button type="button" className={`v3-toggle ${formData.isOtherAttendeeRequired ? "on" : "off"}`} onClick={() => onInputChange('isOtherAttendeeRequired', !formData.isOtherAttendeeRequired)}>
                <span className="v3-toggle-knob" />
              </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ flex: 1, paddingRight: 20 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Terms &amp; Conditions</div>
                  <p style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", margin: "4px 0 0 0" }}>
                    Customers must agree to your event terms before completing booking.
                  </p>
                </div>
                <button type="button" className={`v3-toggle ${formData.hasTermsAndConditions ? "on" : "off"}`} onClick={() => onInputChange('hasTermsAndConditions', !formData.hasTermsAndConditions)}>
                  <span className="v3-toggle-knob" />
                </button>
              </div>

              {formData.hasTermsAndConditions && (
                <div style={{ background: "rgba(255,255,255,0.02)", borderRadius: 12, border: "1px solid rgba(255,255,255,0.08)", padding: 2 }}>
                  <ReactQuill
                    className={`text-editor ${isFieldInvalid(formData.hasTermsAndConditions, formData.termsAndConditions, 'termsAndConditions') ? 'is-invalid' : ''}`}
                    value={formData.termsAndConditions}
                    onChange={(value) => onInputChange("termsAndConditions", value)}
                    theme="snow"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <LearnMoreModal
        isOpen={learnMoreModal}
        toggle={() => toggleLearnMoreModal('')}
        field={learnMoreModalField}
      />
    </>
  );
};

export default EventSettingsTab;